export default __webpack_public_path__ + "static/media/28-SecludedCreek.f27b937c.jpeg";